import { useState, useEffect } from 'react';
import Navbar from '@material-tailwind/react/Navbar';
import NavbarWrapper from '@material-tailwind/react/NavbarWrapper';
import NavbarCollapse from '@material-tailwind/react/NavbarCollapse';
import NavLink from '@material-tailwind/react/NavLink';
import Logo from "../assets/logo/LogoKingN.svg";
import MenuIcon from '../assets/elements/SVG ASSETS/MenuHamb.svg'
import MenuCloseIcon from '../assets/elements/SVG ASSETS/MenuHamb_close.svg'

import Social from './Social';
import { SNAPSHOTS_URL } from '../services/snapshotNetworks';

function Header() {

  const [openNavbar, setOpenNavbar] = useState(false);

  const handleKeyDown = (event: any) => {
        if(event.target.id!=='openNav'){
            setOpenNavbar(false)
        }
      };
    
      useEffect(() => {
        window.scroll(0,0);
        window.addEventListener('click', handleKeyDown);
    
        return () => {
          window.removeEventListener('click', handleKeyDown);
        };
      }, []);

  return (
    <Navbar className="nav-bg grid grid-cols-1 lg:grid-cols-6 gap-4 navbar-container" navbar>
      <NavbarWrapper className='flex col-span-2 logo-header pr-5 lg:pr-0'>
        <a
          href="/"
          rel="noreferrer"
          className='logo-container'
        >
          <img className='logo' src={Logo} alt='Kingnodes' />
        </a>

        <button id='openNav' aria-label={openNavbar ? 'Close menu' : 'Open menu'} aria-expanded={openNavbar} className={`hidden-component-revert ${openNavbar?'menu-button':''}`} onClick={() => setOpenNavbar(!openNavbar)}>
          <img id='openNav' src={openNavbar ? MenuCloseIcon : MenuIcon} alt="" />
        </button>
      </NavbarWrapper>
      <NavbarCollapse open={openNavbar} className="col-span-4 flex flex-col-reverse lg:flex-row nav-collapse" icon={Logo}>
        <div className='flex-1 full-web-kit'>
          <div className='flex flex-col lg:flex-row justify-around nav-container-buttons'>
            <NavLink
              className='text-base nav-button'
              href="/#Benefits"
              rel="noreferrer"
              ripple="light"
            >
              <button className='text-base text-center'>Our Benefits</button>
            </NavLink>
            <NavLink
              className='text-base nav-button'
              href="/#cryptos"
              rel="noreferrer"
              ripple="light"
            >
              <button className='text-base text-center'>Networks</button>
            </NavLink>
            <NavLink
              className='text-base nav-button'
              href={SNAPSHOTS_URL}
              ripple="light"
            >
              <button className='text-base text-center'>Snapshots</button>
            </NavLink>
            <NavLink
              className='text-base nav-button'
              href="/#ContactUs"
              rel="noreferrer"
              ripple="light"
            >
              <button className='text-base'>Contact Us</button>
            </NavLink>
          </div>
        </div>
        <div className='flex flex-2 xl:flex-1 nav-links justify-contact-items header-items'>
          <Social />
        </div>
      </NavbarCollapse>
    </Navbar>
  );
}

export default Header;
